import React from 'react'

const Download = () => {
    return (
        <>
            <div className="grid lg:grid-cols-2 gap-5 place-items-center h-[calc(100vh-200px)]">
                <div>
                    <img src="/assets/images/vertex.png" alt="download" className='p-1 object-contain ' />
                </div>
                <div className='px-7 flex flex-col justify-evenly'>
                    <h1 className='text-3xl mb-2 font-bold'>Vertex For Mobile And Desktop</h1>
                    <p className='my-2 mb-5'>Download Vertex for mobile and desktop on your smartphone or tablet. Vertex is a powerful trading platform that allows you to trade stocks, futures, and options. With its intuitive interface, advanced features, and support for multiple currencies, Vertex is a popular choice for beginners and professionals.</p>
                    <p className='my-2 text-lg'>Available for Android, IOS and Windows</p>
                    <div className="flex gap-1">
                        <a href='https://www.hybridsolutions.com/downloads/capitalfx.exe'>
                            <img src="/assets/images/windows.png" alt="windows" className='h-9 ' />
                        </a>
                        <a href='https://www.hybridsolutions.com/downloads/Mobile/VertexFXTraderPro.apk'>
                            <img src="/assets/images/android.png" alt="APK" className='h-9 ' />
                        </a>
                        <a href='https://apps.apple.com/us/app/vertexfx-trader-pro/id6742178081'>
                            <img src="/assets/images/ios.png" alt="iOS" className='h-9 ' />
                        </a>

                    </div>
                    <a href="#" className="button"></a>
                </div>

            </div>
        </>
    )
}

export default Download